import { motion } from "framer-motion";
import { Reveal, Kicker } from "./Reveal";

const ABOUT_IMG = "https://images.pexels.com/photos/4351727/pexels-photo-4351727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900";

export const About = () => {
    return (
        <section
            id="despre"
            data-testid="about-section"
            className="relative bg-white py-24 text-neutral-900 md:py-36"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 md:px-12 lg:grid-cols-12 lg:gap-20">
                {/* Text */}
                <div className="lg:col-span-7">
                    <Reveal>
                        <Kicker dark>Despre noi</Kicker>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                            Despre <br className="hidden sm:block" />
                            <span className="text-neutral-400">GAN BARBERSHOP</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <p className="mt-8 max-w-xl font-body text-lg leading-relaxed text-neutral-600">
                            La GAN BARBERSHOP credem că o tunsoare bună îți oferă încredere
                            și stil. Punem accent pe calitate, atenție la detalii și o
                            experiență relaxantă pentru fiecare client.
                        </p>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-5 max-w-xl font-accent text-xl italic leading-relaxed text-neutral-800">
                            Aducem arta frizeriei la un alt nivel, combinând tehnica
                            clasică cu un mediu modern și premium.
                        </p>
                    </Reveal>

                    <div className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-neutral-200 pt-10">
                        {[
                            { n: "10+", l: "Ani experiență" },
                            { n: "6k+", l: "Clienți mulțumiți" },
                            { n: "6", l: "Servicii premium" },
                        ].map((s, i) => (
                            <Reveal key={s.l} delay={0.1 * i}>
                                <div>
                                    <div className="font-display text-3xl font-semibold tracking-tight md:text-4xl">
                                        {s.n}
                                    </div>
                                    <div className="mt-1 font-body text-xs uppercase tracking-widest text-neutral-500">
                                        {s.l}
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                {/* Image with clipped frame */}
                <div className="lg:col-span-5">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        className="relative"
                    >
                        <div className="relative aspect-[3/4] overflow-hidden">
                            <img
                                src={ABOUT_IMG}
                                alt="Frizer GAN BARBERSHOP la lucru cu precizie"
                                className="img-cover"
                                loading="lazy"
                            />
                        </div>
                        <div className="absolute -bottom-4 -left-4 h-24 w-24 border-b-2 border-l-2 border-gold" />
                        <div className="absolute -right-4 -top-4 h-24 w-24 border-r-2 border-t-2 border-gold" />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
